import React from 'react'
import { Col, Grid, PaymentLogo, PaymentMethod, Tooltip, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styles from 'modules/Billing/Billing.module.scss'
import clsx from 'clsx'

const PaymentMethods = ({ data = [], handleClickSlider = () => {}, className = '' }) => {
  const { t } = useTranslation(['billing'])

  return (
    <div className={className}>
      <div className={clsx(styles['billing__label'], 'margin-bottom-40')}>
        {t('choose_payment_method')}
      </div>
      <div className={styles['billing__list']}>
        <Grid gap={16}>
          {data.map(({ method, bonus_percent = 0, title, active = false }) => (
            <Col
              lg={3}
              sm={4}
              // xs={6}
              s={6}
              key={method}
              className={styles['billing__list-item']}
              onClick={() => handleClickSlider(method)}
            >
              <PaymentMethod
                backgroundColor={`var(--network-color-${method}, #1c84ff)`}
                active={active}
                icon={
                  <PaymentLogo
                    name={method}
                    type={'inner'}
                  />
                }
              >
                <>
                  {bonus_percent !== 0 && (
                    <div className={styles['billing__list-corner']}>
                      <Tooltip title={t('client_in_moderation')}>{bonus_percent}%</Tooltip>
                    </div>
                  )}
                  <Typography
                    variant={'Body-15'}
                    className={styles['billing__list-heading']}
                  >
                    {title}
                  </Typography>
                </>
              </PaymentMethod>
            </Col>
          ))}
        </Grid>
      </div>
    </div>
  )
}

PaymentMethods.propTypes = {
  data: PropTypes.array,
  handleClickSlider: PropTypes.func,
  className: PropTypes.string,
}

export default PaymentMethods
